import _ from "lodash";
import {
    ADD_PRODUCT,
    FETCH_PRODUCTS,
    EDIT_PRODUCT,
} from "../actions/types";

const INITIAL_STATE = {
    products: {},
}

const productReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case ADD_PRODUCT:
            return { ...state, products: { ...state.products, [action.payload.products.id]: action.payload.products } }
        case FETCH_PRODUCTS:
            return { ...state, products: { ...state.products, ..._.mapKeys(action.payload.products, 'id') } }
        case EDIT_PRODUCT:
            return { ...state, products: { ...state.products, [action.payload.products.id]: action.payload.products } }
        default:
            return state;
    }
};

export default productReducer